import { Fragment } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";
import { updateSetting } from "actions/userSetiting";
import SelectBox from "components/elements/selectBox";
import { Languages } from "helper/constant";

function ModalSetting({ isOpen, onToggle, settings, onFormChange, updateSetting }) {
    const { t } = useTranslation();
    const handleSubmit = () => {
        updateSetting(settings);
    };

    return (
        <Fragment>
            <Modal
                centered={true}
                size="lg"
                toggle={() => {
                    onToggle();
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h1 className="mb-0 text-dark">{t("Setting")}</h1>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onToggle();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                    <span className="required">{t("Auto Send Translate")}</span>
                                </label>
                                <div className="form-check form-check-solid form-switch form-check-custom fv-row">
                                    <input
                                        className="form-check-input w-45px h-30px"
                                        type="checkbox"
                                        checked={settings?.autoTranslate || false}
                                        name="autoTranslate"
                                        onChange={(e) => {
                                            onFormChange(e);
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="manage_product"></label>
                                </div>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                                <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                    <span className="required">{t("Language Translate")}</span>
                                </label>
                                <SelectBox
                                    options={Languages}
                                    placeholder="Select language"
                                    value={settings?.languageTranslate || ""}
                                    onChange={(data) => {
                                        onFormChange({ target: { name: "languageTranslate", value: data.value } });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={onToggle}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        onClick={handleSubmit}
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                    >
                        {t("Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = { updateSetting };

export default connect(mapStateToProps, mapDispatchToProps)(ModalSetting);
